import React from 'react';

interface ExclamationCircleSVGAlternativeProps {
	class: string;
}

/**
 * Check SVG
 *
 * @returns
 */
function ExclamationCircleSVGAlternative(props: ExclamationCircleSVGAlternativeProps) {
	return (
		<svg
			viewBox="0 0 38 32"
			className={'icon icon-exclamation-circle-2 ' + props.class}
			focusable="false"
			aria-hidden="true"
		>
			<path d="M16.001 32c8.836 0 15.999-7.163 15.999-15.999s-7.163-15.999-15.999-15.999c-8.836 0-15.999 7.163-15.999 15.999v0c0 8.836 7.163 15.999 15.999 15.999v0zM16.001 6.924c1.020 0 1.846 0.827 1.846 1.846s-0.827 1.846-1.846 1.846c-1.020 0-1.846-0.827-1.846-1.846v0c0-1.020 0.827-1.846 1.846-1.846v0zM14.155 14.924c0-1.020 0.827-1.846 1.846-1.846s1.846 0.827 1.846 1.846v8.615c0 1.020-0.827 1.846-1.846 1.846s-1.846-0.827-1.846-1.846v0z" />
		</svg>
	);
}

// Set default props
ExclamationCircleSVGAlternative.defaultProps = {
	class: '',
};

export default ExclamationCircleSVGAlternative;
